import Vue from "vue";
import NotificationWrapper from "./notification.vue";
import { type NotificationParams, type NotificationItem } from "./notification";

export * from "./notification";

const DEFAULT_DURATION = 5000;

let isMounted = false;
let idCounter = 0;

const state = Vue.observable({
    items: [] as NotificationItem[],
});

function removeById(id: number): void {
    const index = state.items.findIndex((item) => item.id === id);
    if (index !== -1) {
        state.items.splice(index, 1);
    }
}

function ensureMounted(): void {
    if (isMounted) return;
    isMounted = true;

    const container = document.createElement("div");
    document.body.appendChild(container);

    new Vue({
        render: (h) =>
            h(NotificationWrapper, {
                props: { notifications: state.items },
                on: { close: removeById },
            }),
    }).$mount(container);
}

export function UINotification(params: NotificationParams): void {
    ensureMounted();

    idCounter += 1;
    const id = idCounter;
    const duration = params.duration ?? DEFAULT_DURATION;

    state.items.push({
        id,
        type: params.type ?? "success",
        title: params.title,
        text: params.text,
        component: params.component,
        html: params.html,
        duration,
    });

    setTimeout(() => removeById(id), duration);
}
